export default __webpack_public_path__ + "static/media/gitlab-original.9d0884b3.svg";